<template>
	<div class="height-100dvh">
		<div id="hideinlaptop" class="mob-back-header d-flex align-items-center">
			<img
				class="mr-3"
				src="../../assets/mobile/assprog/mobileBackArrow.svg"
				alt=""
				@click="$router.go(-1)"
			/>
			Become a Panelist
		</div>
		<main class="appr-main-container w-100">
			<div id="hideinmobile" class="cand-header d-flex mb-2">
				<img
					@click="$router.go(-1)"
					class="mr-3 d-flex pointer"
					src="../../assets/img/homepage/back-arrow-blue.svg"
					alt=""
				/>
				Become a panelist
			</div>
			<div
				:class="showTrans ? 'card-blur' : ''"
				class="appr-down-cont max-1825"
				v-if="!loader"
			>
				<section class="appr-panel-info">
					<div class="appr-w-100">
						<div class="d-flex align-items-start">
							<img
								class="appr-hello-svg mr-2"
								src="../../assets/newdesign/BecomePanelist/hello.svg"
								alt=""
							/>
							<h3
								class="appr-black-txt fam-mont fw-M text-darkgrey mb-0 appr-mob-width text-break"
							>
								Hi, {{ selectedAssessment.name }}
							</h3>
							<article
								class="appr-red-alert appr-alert"
								v-if="
									selectedAssessment &&
									selectedAssessment.linkedIn &&
									selectedAssessment.linkedIn.status == 2
								"
							>
								<img
									src="../../assets/newdesign/BecomePanelist/alert-red.svg"
									alt=""
								/>Action required
							</article>
						</div>
						<div class="appr-flex">
							<div class="appr-flex-2">
								<span class="appr-grey-txt text-lightgrey fam-lato fw-LM w-92px"
									>Applied Industry:</span
								>
								<div class="appr-grey-txt text-blue fam-lato fw-M">
									{{ selectedAssessment.industryName }}
								</div>
							</div>
							<div class="appr-flex-4">
								<span
									class="appr-grey-txt text-lightgrey fam-lato fw-LM w-92px"
								>
									Applied Skill(s):
								</span>
								<div style="display: inline-flex; flex-wrap: wrap">
									<div class="d-flex flex-wrap mr-2">
										<span
											v-for="(skill, index) in visibleSkills"
											:key="index"
											class="appr-grey-txt text-blue fam-lato fw-M"
										>
											<span>{{ skill }}</span
											><span
												v-if="index < visibleSkills.length - 1"
												class="mx-1"
												>,</span
											>
										</span>
									</div>

									<div
										v-if="remainingSkills.length > 0"
										class="appr-grey-txt text-blue underline fam-lato fw-M"
									>
										<span v-b-tooltip.bottom="remainingSkills.join(', ')">
											+{{ remainingSkills.length }} more
										</span>
									</div>
								</div>
							</div>
						</div>
						<div class="appr-flex">
							<div class="appr-flex-2">
								<span class="appr-grey-txt text-lightgrey fam-lato fw-LM w-92px"
									>LinkedIn Profile:</span
								>
								<article
									id="hideinlaptop"
									class="appr-red-alert-2 appr-alert"
									:class="
										selectedAssessment.linkedIn?.status == 0
											? 'appr-yel-alert'
											: selectedAssessment.linkedIn?.status == 1
											? 'appr-green-alert'
											: 'appr-red-alert'
									"
								>
									<img
										:src="getImgLink(selectedAssessment.linkedIn?.status)"
										alt=""
									/>{{
										selectedAssessment.linkedIn?.status == 0
											? "Pending for verification"
											: selectedAssessment.linkedIn?.status == 1
											? "Verified"
											: "Rejected"
									}}
								</article>
							</div>
							<div class="appr-flex-3">
								<div
									class="appr-grey-txt text-blue fam-lato fw-M underline pointer text-break pr-4"
									@click="openLinkedin(selectedAssessment.linkedIn?.link)"
								>
									{{ selectedAssessment.linkedIn?.link }}
								</div>
								<div
									v-if="selectedAssessment.linkedIn?.status == 2"
									@click="openLinkedinVerify"
									id="hideinlaptop"
									class="candash-addBtn-sm pointer"
								>
									Re-verify
								</div>
								<article
									id="hideinmobile"
									class="appr-red-alert-2 appr-alert ml-2"
									:class="
										selectedAssessment.linkedIn?.status == 0
											? 'appr-yel-alert'
											: selectedAssessment.linkedIn?.status == 1
											? 'appr-green-alert'
											: 'appr-red-alert'
									"
								>
									<img
										:src="getImgLink(selectedAssessment.linkedIn?.status)"
										alt=""
									/>
									{{
										selectedAssessment.linkedIn?.status == 0
											? "Pending for verification"
											: selectedAssessment.linkedIn?.status == 1
											? "Verified"
											: "Rejected"
									}}
								</article>
								<div
									v-if="selectedAssessment.linkedIn?.status == 2"
									id="hideinmobile"
									@click="openLinkedinVerify"
									class="fs-16 fw-M fam-lato text-blue underline ml-3 d-flex align-items-center gap-2 pointer"
								>
									Re-verify now
								</div>
							</div>
						</div>
					</div>
					<div class="status">
						<h1 class="fam-mont fs-32 fw-M text-blue">
							{{ getCompletion() }}/{{ getTotal() }}
						</h1>
						<h2 class="fam-mont fs-14 fw-R text-black">Complete</h2>
					</div>
				</section>
				<section
					class="appr-yellow-card"
					v-if="
						selectedAssessment &&
						selectedAssessment.progress &&
						selectedAssessment.progress.length > 0
					"
				>
					<div class="width" v-if="!specialCase">
						<!-- {{ getDescription() }} -->
						{{
							stepMessages(
								selectedAssessment.progress[
									selectedAssessment.currentLevel - 1
								],
								"message"
							)
						}}
						{{
							stepMessages(
								selectedAssessment.progress[
									selectedAssessment.currentLevel - 1
								],
								"message1"
							)
						}}
						{{
							stepMessages(
								selectedAssessment.progress[
									selectedAssessment.currentLevel - 1
								],
								"message2"
							)
						}}
						<!-- Please schedule your assessment depending on your availability for
						taking the assessment. -->
					</div>
					<div class="width" v-else>
						<!-- {{ getDescription() }} -->
						{{
							stepMessages(
								selectedAssessment.progress[selectedAssessment.currentLevel],
								"message"
							)
						}}
						{{
							stepMessages(
								selectedAssessment.progress[selectedAssessment.currentLevel],
								"message1"
							)
						}}
						{{
							stepMessages(
								selectedAssessment.progress[selectedAssessment.currentLevel],
								"message2"
							)
						}}
						<!-- Please schedule your assessment depending on your availability for
						taking the assessment. -->
					</div>
					<div
						class="position-relative"
						v-if="
							selectedAssessment.progress[selectedAssessment?.currentLevel - 1]
								.status !== 1
						"
					>
						<b-button
							:disabled="
								specialCase
									? shouldDisableButton(
											selectedAssessment.progress[
												selectedAssessment.currentLevel
											],
											selectedAssessment.currentLevel
									  )
									: shouldDisableButton(
											selectedAssessment.progress[
												selectedAssessment.currentLevel - 1
											],
											selectedAssessment.currentLevel - 1
									  )
							"
							@click="
								specialCase
									? goToCvs(
											selectedAssessment.progress[
												selectedAssessment.currentLevel
											]
									  )
									: goToCvs(
											selectedAssessment.progress[
												selectedAssessment?.currentLevel - 1
											]
									  )
							"
							id="hideinmobile"
							class="candash-addBtn"
							:class="
								buttonLoader[
									selectedAssessment.progress[
										selectedAssessment?.currentLevel - 1
									].id
								] &&
								currentId ===
									selectedAssessment.progress[
										selectedAssessment?.currentLevel - 1
									].id
									? 'text-blue'
									: ''
							"
							>{{
								!specialCase
									? getText(
											selectedAssessment.progress[
												selectedAssessment?.currentLevel - 1
											]
									  )
									: selectedAssessment.currentLevel == 3
									? getText(
											selectedAssessment.progress[
												selectedAssessment.currentLevel
											]
									  )
									: getText(
											selectedAssessment.progress[
												selectedAssessment.currentLevel - 1
											]
									  )
							}}</b-button
						>
						<div
							v-if="
								buttonLoader[
									selectedAssessment.progress[
										selectedAssessment?.currentLevel - 1
									].id
								] &&
								currentId ===
									selectedAssessment.progress[
										selectedAssessment?.currentLevel - 1
									].id
							"
							class="loader-pos-new"
						>
							<Loader />
						</div>
					</div>

					<img
						@click="handleArrowClick"
						id="hideinlaptop"
						src="../../assets/newdesign/myprofile/roundRightArrow.svg"
						:class="{ 'opac-5': isArrowDisabled }"
						alt=""
					/>
				</section>
				<section class="d-flex align-items-center justify-content-between mt-2">
					<div class="appr-hor-line"></div>
					<div class="appr-ur-txt fam-lato fw-LM text-grey">Your progress</div>
					<div class="appr-hor-line"></div>
				</section>
				<section class="appr-horizontal-scroll mt-2" ref="scrollContainer">
					<div
						class="appr-card-parent"
						v-for="(data, index) in selectedAssessment.progress"
						:key="index"
					>
						<b-card
							class="asspr-cards"
							:class="[
								getBorderClass(data, index),
								// when th currentlevel is 3 and linkdin status is 2 then and special case is true then also opac-5 should not come
								(selectedAssessment.currentLevel < index + 1 && !specialCase) ||
								data.skipped
									? 'opac-5'
									: '',
							]"
						>
							<div class="p-3">
								<div class="d-flex align-items-center">
									<img
										class="mr-3 mob-img"
										:src="getImgUrl(data.type)"
										alt=""
									/>
									<div>
										<h2 class="fam-mont fw-M text-black appr-black-txt mb-0">
											{{ data.name }}
										</h2>
										<article class="appr-grey-tag mt-2">
											Step {{ getStepText(data.id) }}
										</article>
									</div>
								</div>
								<div
									class="appr-card-height"
									:class="
										data.type == 'f2f' && (data.date || data.preferredSlot)
											? 'appr-card-height-2'
											: 'appr-card-height'
									"
								>
									<article
										class="appr-blue-slot"
										v-if="
											(data.type == 'f2f' &&
												data.date &&
												!data.pendingEvaluation &&
												!interviewExpired) ||
											(data.preferredSlot &&
												!data.pendingEvaluation &&
												!interviewExpired)
										"
									>
										<h3 class="fam-lato fw-R text-darkgrey">Slot details:</h3>

										<h4
											class="fam-lato fw-B text-blue"
											v-if="data.status == 0 && data.date"
										>
											{{ formatDateTime(data.date, data.startTime) }}
										</h4>
										<h4 class="fam-lato fw-B text-blue" v-else>
											{{ convertToLocal(data.preferredSlot) }}
										</h4>
										<h5
											v-if="
												isInterviewInProgress(
													data.date,
													data.startTime,
													data.duration
												)
											"
											class="fam-lato fw-R"
										>
											Your interview has started. click on "Join Meeting" to
											attend the interview.
										</h5>
										<h5
											class="fam-lato fw-R"
											v-else-if="data.date && data.startTime"
										>
											Please ensure your availability at the scheduled time, as
											rescheduling or reattempts will not be permitted.
										</h5>
										<h5 class="fam-lato fw-R" v-else>
											You have successfully submitted your "Interview Slot" .
											Please wait.
										</h5>
									</article>
									<span class="appr-card-txt" v-else>
										{{ stepMessages(data, "message") }}
										<span class="text-blue fw-B">{{
											stepMessages(data, "message1")
										}}</span>
										{{ stepMessages(data, "message2") }}
										<!-- <span>{{ stepMessages(data, "message3") }}</span>
										{{ stepMessages(data, "message4") }} -->
									</span>
									<div
										class="appr-card-grey-tag mt-auto"
										v-if="
											!data.link &&
											!specialCase &&
											!data.preferredSlot &&
											!data.skipped
										"
									>
										Not yet unlocked
									</div>
									<div
										class="appr-card-green-tag mt-auto"
										v-else-if="data.status == '1'"
									>
										<img
											src="../../assets/newdesign/BecomePanelist/alert-green.svg"
											alt=""
										/>Verified
									</div>
									<div
										class="mt-auto"
										:class="{
											'appr-card-red-tag ':
												(data.status == '0' && !data?.retriggerRequest) ||
												(data.status == '2' && !data?.retriggerRequest) ||
												specialCase,
											'appr-card-yellow-tag':
												(data.pendingEvaluation && data?.status == '0') ||
												((data?.status == '2' || data?.status == '0') &&
													data?.retriggerRequest) ||
												(specialCase &&
													data.type == 'f2f' &&
													selectedAssessment.linkedIn.status == 0),
										}"
										v-else-if="
											(data.type == 'f2f' &&
												!data.date &&
												!data.preferredSlot &&
												data.status == '0') ||
											(data.status == '0' &&
												!data.preferredSlot &&
												!data.skipped) ||
											data.status == '2' ||
											(specialCase && !data.preferredSlot && !data.skipped)
										"
									>
										<img
											v-if="
												(!data.pendingEvaluation &&
													data.status == '0' &&
													!data?.retriggerRequest) ||
												((data.status == '2' || data.status == '0') &&
													!data?.retriggerRequest &&
													!data.pendingEvaluation) ||
												(specialCase &&
													data.type == 'f2f' &&
													!selectedAssessment.linkedIn.status == 0)
											"
											src="../../assets/newdesign/BecomePanelist/alert-red.svg"
											alt=""
										/>
										<img
											v-else
											src="../../assets/newdesign/BecomePanelist/alert-yellow.svg"
											alt=""
										/>{{ getStatusText(data) }}
									</div>
								</div>
							</div>
							<div class="appr-card-footer-green" v-if="data.status == '1'">
								Completed
							</div>
							<div
								class="appr-card-footer-grey"
								v-else-if="data.isDisabled || (data.skipped && data.id == 3)"
							>
								Not Required
							</div>
							<div
								class="appr-card-footer position-relative"
								v-else-if="checkStatus(data.status)"
							>
								<b-button
									@click="goToCvs(data)"
									:disabled="shouldDisableButton(data, index)"
									:class="
										buttonLoader[data.id] && currentId === data.id
											? 'text-blue'
											: ''
									"
									class="candash-addBtn-ats w-100"
									>{{ getText(data) }}</b-button
								>
								<div
									v-if="buttonLoader[data.id] && currentId === data.id"
									class="loader-pos-new"
								>
									<Loader />
								</div>
							</div>
						</b-card>
						<img
							v-if="index < selectedAssessment.progress.length - 1"
							id="hideinmobile"
							src="../../assets/newdesign/BecomePanelist/card-lines.svg"
							alt=""
						/>
						<img
							v-if="index < selectedAssessment.progress.length - 1"
							id="hideinlaptop"
							src="../../assets/newdesign/BecomePanelist/card-lines-ver.svg"
							alt=""
						/>
					</div>
				</section>
				<input
					id="hideinmobile"
					v-model="scrollValue"
					type="range"
					min="0"
					:max="scrollMax"
					@input="scrollCards"
					class="slider pointer my-3"
					v-show="scrollMax > 0"
				/>
			</div>
			<template v-else>
				<section
					class="appr-panel-info flex-column align-items-start gap-3 max-1825"
					style="min-height: 127px"
				>
					<b-skeleton class="w20"></b-skeleton>
					<b-skeleton class="w-50"></b-skeleton>
					<b-skeleton class="w-75"></b-skeleton>
				</section>
				<section class="appr-yellow-card max-1825">
					<div class="width">
						<b-skeleton class="w-100"></b-skeleton>
					</div>
				</section>
				<section
					class="d-flex align-items-center justify-content-between mt-2 max-1825"
				>
					<div class="appr-hor-line"></div>
					<div class="appr-ur-txt fam-lato fw-LM text-grey">Your progress</div>
					<div class="appr-hor-line"></div>
				</section>
				<section class="appr-horizontal-scroll mt-2 max-1825">
					<div v-for="i in 4" :key="i" class="appr-card-parent">
						<b-card
							class="asspr-cards appr-white-border d-flex flex-column p-3"
						>
							<div class="d-flex align-items-center gap-2">
								<b-skeleton
									type="avatar"
									height="64px"
									width="64px"
								></b-skeleton>
								<div style="flex: 1">
									<b-skeleton class="w-50"></b-skeleton>
									<b-skeleton class="w-75"></b-skeleton>
								</div>
							</div>
							<div class="appr-card-height mt-3">
								<b-skeleton class="w-100"></b-skeleton>
								<b-skeleton class="w-100"></b-skeleton>
								<b-skeleton class="w-50"></b-skeleton>
							</div>

							<b-skeleton type="input" class="mt-auto"></b-skeleton>
						</b-card>
						<img
							id="hideinmobile"
							src="../../assets/newdesign/BecomePanelist/card-lines.svg"
							alt=""
						/>
						<img
							id="hideinlaptop"
							src="../../assets/newdesign/BecomePanelist/card-lines-ver.svg"
							alt=""
						/>
					</div>
				</section>
			</template>
			<Transition name="slidemob">
				<div v-if="showTrans" class="filter-box-mob-2 position-fixed">
					<RetryVerification
						@close-modal="showTrans = false"
						@re-verified="closeVerify"
					/>
				</div>
			</Transition>
		</main>
		<b-modal id="interviewSlot" centered hide-footer hide-header>
			<main>
				<section class="interslot-body">
					<h2 class="fam-mont appr-modal-heading mb-3">
						Select an interview slot
					</h2>
					<img
						class="interslot-cross rotate-on-hover pointer"
						src="../../assets/newdesign/myprofile/greyCross.svg"
						alt=""
					/>
					<article>
						Morem ipsum dolor sit amet, consectetur adipiscing elit. Nunc
						vulputate libero et velit interdum, ac aliquet odio mattis.
					</article>
					<div class="d-flex my-3">
						<span class="fam-mont fw-LM fs-16">Select Slot</span>
						<div class="d-flex align-items-center gap-1 ml-3 jdp-red-txt">
							<img
								src="../../assets/newdesign/BecomePanelist/red-i.svg"
								alt=""
							/>Please select slot
						</div>
					</div>
					<section class="position-relative">
						<div class="select-date-parent pb-4">
							<div
								v-for="i in loopvar"
								:key="i"
								class="single-time-date"
								:class="i == 3 ? 'single-time-sel' : ''"
							>
								<h2 class="fam-mont fw-LM fs-14 text-black text-center">
									Monday
								</h2>
								<h3 class="fam-mont fw-R fs-13 text-darkgrey mb-0 text-center">
									14, Sep, 2024
								</h3>
							</div>
						</div>
						<img
							class="select-date-left"
							src="../../assets/newdesign/jobsearch/carouselLeft.svg"
							alt=""
						/>
						<img
							class="select-date-right"
							src="../../assets/newdesign/jobsearch/carouselRight.svg"
							alt=""
						/>
					</section>
					<div class="time-select-parent">
						<div
							v-for="i in loopvar"
							:key="i"
							class="single-time"
							:class="i == 3 ? 'single-time-sel' : ''"
						>
							09:40

							<div v-if="i % 3 != 0" class="single-time-vertical-line"></div>
						</div>
					</div>
				</section>
				<footer
					class="d-flex align-items-center justify-content-between candash-modal-footer"
				>
					<div>
						<div class="fam-lato fs-14 fw-LM text-grey">Slot details:-</div>
						<div class="fam-lato fs-16 fw-B text-blue">
							15th Sep 2024, 06:00 PM
						</div>
					</div>
					<b-button class="candash-addBtn">Book Slot</b-button>
				</footer>
			</main>
		</b-modal>
		<b-modal id="retryVerification" centered hide-footer hide-header>
			<RetryVerification
				@close-modal="$bvModal.hide('retryVerification')"
				@re-verified="closeVerify"
			/>
		</b-modal>
		<InterviewSlotModal
			v-if="showSlots"
			:showSlots="showSlots"
			:applicationLog="selectedAssessment"
			:parentMessage="'Book Slot'"
			:isPanel="true"
			@closeSlots="showSlots = false"
			@updateApplicationLog="getCvsDetails()"
		/>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import mobHeader from "@/components/fixedcomponents/mobileHeader.vue";
import Loader from "@/components/fixedcomponents/Loader.vue";
import {
	getCvsDetails,
	triggerCvs,
	postPanelResult,
	getBufferTime,
} from "@/utils/apiFunctions.js";
import InterviewSlotModal from "@/components/JobProgress/InterviewSlotModal.vue";
import toast from "@/components/mixin/toast";
import RetryVerification from "@/components/MyProfile/RetryVerification.vue";
import { Capacitor } from "@capacitor/core";

export default {
	data() {
		return {
			retriggerCount: 0,
			showResume: null,
			lastbufferTime: null,
			isInterviewChecking: false,
			interviewExpired: false,
			intervalId: null,
			buttonLoader: {},
			currentId: null,
			showVerify: false,
			maxSkills: 10,
			loader: false,
			specialCase: false,
			scrollValue: 0,
			scrollMax: 0,
			text: "",
			showSlots: false,
			showTrans: false,
			isLaptop: false,
			loopvar: 30,
			selectedAssessment: {},
			candidateInfo: {},
			results: "",
			bufferInterval: null,
		};
	},
	components: {
		mobHeader,
		InterviewSlotModal,
		RetryVerification,
		Loader,
	},
	mixins: [toast],
	async created() {
		await this.getCvsDetails();
		this.checkScreenSize();
		this.fetchPanelResults();
		this.calculateScrollMax();
		this.getBufferTime();
	},
	beforeDestroy() {
		window.removeEventListener("resize", this.checkScreenSize);
		window.removeEventListener("message");
		const scrollContainer = this.$refs.scrollContainer;

		if (scrollContainer) {
			// Remove the scroll event listener when the component is destroyed
			scrollContainer.removeEventListener("scroll", this.updateSliderOnScroll);
		}
		clearInterval(this.intervalId);
	},
	mounted() {
		this.updateMaxSkills();
		window.addEventListener("resize", this.updateMaxSkills);
		window.addEventListener("resize", this.checkScreenSize);
		setTimeout(() => {
			const scrollContainer = this.$refs.scrollContainer;
			if (scrollContainer) {
				scrollContainer.addEventListener("scroll", this.updateSliderOnScroll);
				this.checkScreenSize();
			}
		}, 2000);
		window.addEventListener("message", (event) => {
			if (event.data.testSubmitted) {
				this.$router.go(0);
			}
		});
	},
	computed: {
		visibleSkills() {
			return this.selectedAssessment.skills.slice(0, this.maxSkills);
		},
		remainingSkills() {
			return this.selectedAssessment.skills.slice(this.maxSkills);
		},
		isArrowDisabled() {
			if (!this.selectedAssessment || !this.selectedAssessment.progress) {
				return true;
			}

			const data = this.specialCase
				? this.selectedAssessment.progress[
						this.selectedAssessment?.currentLevel
				  ]
				: this.selectedAssessment.progress[
						this.selectedAssessment?.currentLevel - 1
				  ];

			const index = this.specialCase
				? this.selectedAssessment.currentLevel
				: this.selectedAssessment.currentLevel - 1;

			return this.shouldDisableButton(data, index);
		},
		...mapGetters("userVUEX", ["getUserInfo"]),
		userInfo() {
			return this.getUserInfo || {};
		},
	},
	methods: {
		async getBufferTime() {
			const payload = {
				testID:
					this.selectedAssessment.progress[
						this.selectedAssessment.currentLevel - 1
					].testID,
				emailID: this.userInfo.email,
				groupID:
					this.selectedAssessment.progress[
						this.selectedAssessment.currentLevel - 1
					].groupID,
				configID:
					this.selectedAssessment.progress[
						this.selectedAssessment.currentLevel - 1
					].configID,
			};

			const res = await getBufferTime(payload);

			if (res.status === 200 && res.data.data.lastbufferTime != null) {
				let lastBufferTimeUTC = res.data.data.lastbufferTime + "Z";
				const currentTimeUTC = new Date().toISOString();
				this.lastbufferTime = new Date(lastBufferTimeUTC).toISOString();
				this.retriggerCount =
					this.selectedAssessment.currentLevel === 2
						? res.data.data.assessmentRetriggerRequestCount
						: res.data.data.sandboxRetriggerRequestCount;

				if (currentTimeUTC < lastBufferTimeUTC) {
					this.showResume = true;
					this.startCountdown(new Date(lastBufferTimeUTC));

					if (this.bufferInterval) clearInterval(this.bufferInterval);

					this.bufferInterval = setInterval(async () => {
						const now = new Date();
						if (now.toISOString() < lastBufferTimeUTC) {
							await this.getBufferTime();
						} else {
							clearInterval(this.bufferInterval);
							this.showResume = false;
						}
					}, 60000);
				} else {
					this.showResume = false;
					if (this.bufferInterval) clearInterval(this.bufferInterval);
				}
			}
		},
		startCountdown(lastBufferTime) {
			const interval = setInterval(() => {
				const currentTime = new Date();

				const timeRemaining = lastBufferTime - currentTime;

				if (timeRemaining <= 0) {
					clearInterval(interval);
					this.showResume = false;
					this.$forceUpdate();
				} else {
					const minutesRemaining = Math.floor(timeRemaining / 60000);
					const secondsRemaining = Math.floor((timeRemaining % 60000) / 1000);
				}
			}, 30000);
		},
		stepMessages(data, currentText) {
			const messages = {
				cvs: {
					default: [
						"Your",
						"Candidate Verification and Screening",
						'has been initiated. Click "Start CVS" to proceed.',
					],
					pending: [
						"You have successfully submitted your",
						'"Candidate Verification and Screening"',
						".Please wait for further updates.",
					],
					retrigger: [
						"You have successfully submitted your",
						'"Retrigger Request"',
						".Please wait for further updates.",
					],
					unsuccessful: [
						"Your",
						'"Candidate Verification and Screening"',
						"was unsuccessful. You can request a re-verification.",
					],
					completed: [
						"You have successfully completed your",
						'"Candidate Verification and Screening"',
						".",
					],
					expired: [
						"Your",
						'"Candidate Verification and Screening"',
						"expired. You can request a re-verification.",
					],
				},
				assessment: {
					default: [
						"Assessment has not been scheduled yet. Please wait.",
						"",
						"",
					],
					pending: [
						"You have successfully submitted your",
						'"Assessment"',
						".Please wait for further updates.",
					],
					retrigger: [
						"You have successfully submitted your",
						'"Retrigger Request"',
						".Please wait for further updates.",
					],
					available: [
						"",
						'"Assessment"',
						'is now available. Click on "Start Test" to proceed.',
					],
					rejected: [
						"Your",
						'"Assessment"',
						"test submission was rejected. You can request a retest.",
					],
					completed: [
						"You have successfully completed your",
						'"Assessment"',
						".",
					],
					timeExpired: [
						"Your",
						'"Assessment"',
						"test submission time Expired.Please request a retest.",
					],
					onGoing: [
						"Your",
						'"Assessment"',
						"test is currently in progress. Please resume test to complete before time expires.",
					],
					retriggerOver: [
						"Your",
						'"Assessment"',
						"test submission time expired. Please Raise a query",
					],
					expired: [
						"Your",
						'"Assessment"',
						"test expired. Please request a retest.",
					],
				},
				sandbox: {
					default: [
						"Sandbox test has not been scheduled yet. Please wait.",
						"",
						"",
					],
					skipped: [
						"This round has been skipped for you. You may proceed to the next step in the process.",
						"",
						"",
					],
					retrigger: [
						"You have successfully submitted your",
						'"Retrigger Request"',
						". Please wait for further updates.",
					],
					pending: [
						"You have successfully submitted your",
						'"Sandbox Test"',
						".Please wait for further updates.",
					],
					available: [
						"",
						'"Sandbox Test"',
						'is now available. Click on "Start Test" to proceed.',
					],
					rejected: [
						"Your",
						'"Sandbox Test"',
						"test submission was rejected. You can request a retest.",
					],
					completed: [
						"You have successfully completed your",
						'"Sandbox Test"',
						".",
					],
					timeExpired: [
						"Your",
						'"Sandbox Test"',
						"test submission time Expired. Please request a retest.",
					],
					retriggerOver: [
						"Your",
						'"Sandbox Test"',
						"test submission time expired. Please Raise a query",
					],
					expired: [
						"Your",
						'"Sandbox Test"',
						"test expired. Please request a retest.",
					],
					onGoing: [
						"Your",
						'"Sandbox Test"',
						"test is currently in progress. Please resume test to complete before time expires.",
					],
				},
				f2f: {
					default: [
						"Your interview has not been scheduled yet. Please wait.",
						"",
						"",
					],
					expired: [
						"Your",
						'"Interview"',
						"has been successfully completed. Please wait",
					],
					pending: [
						"Your",
						'"Interview"',
						"has been successfully completed. Please wait",
					],
					slotSubmitted: [
						"You have successfully submitted your",
						'"Interview Slot"',
						".Please wait for further updates.",
					],
					linkedInPending: [
						"Your",
						'"LinkedIn Verification"',
						"is pending. Please wait for further updates till your LinkedIn profile is verified.",
					],
					linkedInReverify: [
						"Your",
						'"LinkedIn Verification"',
						"is pending. Please re-verify your LinkedIn profile to proceed with your interview process.",
					],
					slotAvailable: [
						"Your",
						'"Interview Slot"',
						"is now available. Please choose your preferred slot.",
					],
					slotRejected: [
						"Your scheduled interview has been cancelled as you did not clear the previous round.",
						"",
						"",
					],
					slotCancelled: [
						"Your selected interview slot has been cancelled as you did not clear the previous round.",
						"",
						"",
					],
				},
			};

			const type = data.type.toLowerCase();
			let key = "default";

			if (type === "cvs") {
				if (data.status === 0 && data.pendingEvaluation) key = "pending";
				else if (
					(data.status === 0 || data.status === 2) &&
					data.retriggerRequest
				)
					key = "retrigger";
				else if (data.status === 2) key = "unsuccessful";
				else if (data.status === 1) key = "completed";
				else if (data.expired && !data.retriggerRequest) key = "expired";
			} else if (type === "assessment" || type === "sandbox") {
				if (data.status === 0 && data.skipped) key = "skipped";
				else if (
					data.status === 0 &&
					!data.pendingEvaluation &&
					this.showResume == false &&
					!data.retriggerRequest &&
					this.retriggerCount < 1
				)
					key = "timeExpired";
				else if (
					data.status === 0 &&
					!data.pendingEvaluation &&
					this.showResume == false &&
					!data.retriggerRequest &&
					this.retriggerCount >= 1
				)
					key = "retriggerOver";
				else if (
					data.status === 0 &&
					!data.pendingEvaluation &&
					this.showResume == true &&
					!data.retriggerRequest
				)
					key = "onGoing";
				else if (
					data.status === 0 &&
					!data.pendingEvaluation &&
					data.expired &&
					!data.retriggerRequest
				)
					key = "expired";
				else if (
					(data.status === 0 || data.status === 2) &&
					data.retriggerRequest
				)
					key = "retrigger";
				else if (data.status === 0 && data.pendingEvaluation) key = "pending";
				else if (data.status === 0) key = "available";
				else if (data.status === 2) key = "rejected";
				else if (data.status === 1) key = "completed";
			} else if (type === "f2f") {
				if (data.cancelled && data.scheduled) key = "slotRejected";
				else if (data.cancelled) key = "slotCancelled";
				else if (
					this.interviewExpired &&
					data.status === 0 &&
					!data.pendingEvaluation
				)
					key = "expired";
				else if (data.status === 0 && data.pendingEvaluation) key = "pending";
				else if (data.preferredSlot) key = "slotSubmitted";
				else if (
					this.selectedAssessment?.linkedIn?.status === 0 &&
					this.specialCase
				)
					key = "linkedInPending";
				else if (
					this.selectedAssessment?.linkedIn?.status === 2 &&
					this.specialCase
				)
					key = "linkedInReverify";
				else if (this.specialCase) key = "slotAvailable";
			}

			const messageArray = messages[type][key] ||
				messages[type].default || ["", "", ""];

			return (
				messageArray[
					currentText === "message1" ? 1 : currentText === "message2" ? 2 : 0
				] || ""
			);
		},
		getBorderClass(data, index) {
			if (data.type == "f2f") {
				return "";
			}
			if (data.status == 0 && (data.skipped || data.pendingEvaluation)) {
				return "appr-grey-border";
			}
			if (data.status == 1) {
				return "appr-green-border";
			}

			if (data.status == 2) {
				return "appr-red-border";
			}

			if (
				this.selectedAssessment.currentLevel == index + 1 ||
				(this.specialCase && this.selectedAssessment.currentLevel == index)
			) {
				return "appr-grey-border";
			}
			return "appr-white-border";
		},
		openLinkedin(link) {
			const cleanedLink = link.replace(/^(https?:\/\/)?(www\.)?/, "");
			const finalLink = `https://www.${cleanedLink}`;
			window.open(finalLink, "_blank");
		},
		isInterviewInProgress(date, startTime, duration) {
			const startDateTimeUTC = new Date(`${date}T${startTime}`);

			if (isNaN(startDateTimeUTC)) {
				return false;
			}

			const endTimeUTC = new Date(
				startDateTimeUTC.getTime() + duration * 60000
			);
			const currentTime = new Date();

			if (!this.isInterviewChecking) {
				this.startInterviewCheck(date, startTime, duration);
			}

			if (currentTime < startDateTimeUTC) {
				this.interviewExpired = false;
				return false;
			}
			if (currentTime >= startDateTimeUTC && currentTime <= endTimeUTC) {
				this.interviewExpired = false;
				return true;
			}

			this.interviewExpired = true;
			this.$forceUpdate();
			return false;
		},

		startInterviewCheck(date, startTime, duration) {
			if (this.isInterviewChecking) return;

			this.isInterviewChecking = true;

			this.intervalId = setInterval(() => {
				const inProgress = this.isInterviewInProgress(
					date,
					startTime,
					duration
				);

				if (!inProgress) {
					clearInterval(this.intervalId);
					this.isInterviewChecking = false;
				}
			}, 60000);
		},

		formatDateTime(dateString, timeString) {
			if (!dateString || !timeString) return "";

			const dateParts = dateString.split(/[\/\-]/);
			let date;

			if (dateParts.length == 3) {
				if (dateParts[0].length === 4) {
					date = new Date(
						parseInt(dateParts[0]),
						parseInt(dateParts[1]) - 1,
						parseInt(dateParts[2])
					);
				} else {
					date = new Date(
						parseInt(dateParts[2]),
						parseInt(dateParts[1]) - 1,
						parseInt(dateParts[0])
					);
				}
			} else {
				return dateString + "," + this.formattedTime(timeString);
			}

			if (isNaN(date.getTime())) {
				return dateString + "," + this.formattedTime(timeString);
			}

			const day = date.getDate();
			const suffix = ["th", "st", "nd", "rd"][
				day % 10 > 3 || (day % 100 >= 11 && day % 100 <= 13) ? 0 : day % 10
			];

			const month = date.toLocaleDateString("en-GB", { month: "short" });
			const year = date.getFullYear();

			return `${day}${suffix} ${month} ${year}, ${this.formattedTime(
				timeString
			)}`;
		},
		convertToLocal(preferredSlot) {
			let date = new Date(preferredSlot);

			if (isNaN(date.getTime())) {
				throw new Error("Invalid date input");
			}

			const day = date.getDate();
			const suffix = ["th", "st", "nd", "rd"][
				day % 10 > 3 || (day % 100 >= 11 && day % 100 <= 13) ? 0 : day % 10
			];

			const formattedDate = date.toLocaleDateString("en-GB", {
				month: "short",
				year: "numeric",
			});

			const formattedTime = date.toLocaleTimeString("en-US", {
				hour: "2-digit",
				minute: "2-digit",
				hour12: true,
			});

			return `${day}${suffix} ${formattedDate}, ${formattedTime}`;
		},
		updateMaxSkills() {
			if (window.innerWidth > 1200) {
				this.maxSkills = 9;
			} else if (window.innerWidth > 900) {
				this.maxSkills = 6;
			} else {
				this.maxSkills = 2;
			}
		},
		async fetchPanelResults() {
			try {
				let payload = {
					userID: this.userInfo.userID,
				};
				const response = await postPanelResult(payload);
				if (response.status === 200) {
					this.results = response.data.data.result;
					if (this.results == "selected" || this.results == "rejected") {
						this.$router.push({
							name: "ResultDashboard",
						});
					}
				}
			} catch (error) {
				console.error("Error fetching:", error);
			}
		},
		getTotal() {
			let total = 0;
			total = this.selectedAssessment?.progress?.length;
			return total;
		},
		shouldDisableButton(data, index) {
			const isSpecialCase =
				(this.selectedAssessment.currentLevel == 3 &&
					this.selectedAssessment.progress[
						this.selectedAssessment.currentLevel - 1
					].status == "0" &&
					this.selectedAssessment.progress[
						this.selectedAssessment.currentLevel - 1
					].pendingEvaluation == true &&
					data.id == 4) ||
				(this.selectedAssessment.currentLevel == 3 &&
					this.selectedAssessment.progress[
						this.selectedAssessment.currentLevel - 1
					].skipped);

			if (
				data.type == "assessment" &&
				this.showResume == false &&
				this.showResume != null &&
				!data.retriggerRequest &&
				!data.pendingEvaluation &&
				!data.expired &&
				data.status !== 1
			) {
				return false;
			}
			if (
				(data.type == "f2f" &&
					this.selectedAssessment.linkedIn.status == 0 &&
					this.specialCase) ||
				(data.type == "f2f" && this.interviewExpired && !data.pendingEvaluation)
			) {
				return true;
			}
			if (
				data.type == "f2f" &&
				this.selectedAssessment.linkedIn.status == 2 &&
				this.selectedAssessment.currentLevel == 3 &&
				this.specialCase
			) {
				return false;
			}
			if (isSpecialCase && data.preferredSlot) {
				this.specialCase = true;
				return true;
			}
			if (isSpecialCase) {
				this.specialCase = true;
				return false;
			}
			return (
				(!data?.link && data?.type != "f2f") ||
				this.selectedAssessment.currentLevel != index + 1 ||
				(data.pendingEvaluation && data?.status == "0") ||
				data.retriggerRequest ||
				(data.status == 1 && !this.specialCase) ||
				(data.preferredSlot && !data.date)
			);
		},
		closeVerify(val) {
			this.showTrans = false;
			this.showVerify = false;
			this.$bvModal.hide("retryVerification");
			this.successModal("Success", "LinkedIn profile sent for verification!");
			this.$nextTick(() => {
				if (val && val.reverified) {
					this.getCvsDetails();
				}
			});
		},
		openLinkedinVerify() {
			if (this.isLaptop) {
				// this.showVerify = true;
				this.$bvModal.show("retryVerification");
			} else {
				this.showTrans = true;
			}
		},
		checkScreenSize() {
			this.isLaptop = window.innerWidth >= 1028;
			this.calculateScrollMax();
		},
		calculateScrollMax() {
			const scrollContainer = this.$refs.scrollContainer;
			if (scrollContainer) {
				const scrollWidth = scrollContainer.scrollWidth;
				const clientWidth = scrollContainer.clientWidth;
				if (scrollWidth > clientWidth) {
					this.scrollMax = scrollWidth - clientWidth;
				} else {
					this.scrollMax = 0;
				}
			}
		},

		scrollCards() {
			// Scroll the content based on the slider value
			const scrollContainer = this.$refs.scrollContainer;
			if (scrollContainer) {
				scrollContainer.scrollLeft = this.scrollValue;
			}
		},
		updateSliderOnScroll() {
			// Update the slider value based on the content scroll position
			const scrollContainer = this.$refs.scrollContainer;
			if (scrollContainer) {
				this.scrollValue = scrollContainer.scrollLeft;
			}
		},
		getCompletion() {
			if (
				this.selectedAssessment &&
				Array.isArray(this.selectedAssessment.progress)
			) {
				const completionCount = this.selectedAssessment.progress.filter(
					(item) => item.status === 1
				);
				return completionCount.length || 0;
			} else {
				return 0;
			}
		},

		getDescription() {
			const description = {
				1: "Please submit your CV for review. Ensure all necessary details are provided for a thorough evaluation.",
				2: "Please begin your assessment at a time that works best for you. Make sure you're prepared and available to complete it.",
				3: "Please begin your test at a time that works best for you. Make sure you're prepared and available to complete it.",
				4: "Please choose a suitable time to schedule your interview. Note that you will not be able to proceed further without scheduling an assessment slot.",
			};

			return this.specialCase
				? description[4]
				: description[this.selectedAssessment.currentLevel];
		},
		getImgLink(status) {
			const images = {
				0: require("../../assets/newdesign/BecomePanelist/alert-blue.svg"),
				1: require("../../assets/newdesign/BecomePanelist/alert-green.svg"),
				2: require("../../assets/newdesign/BecomePanelist/alert-red.svg"),
			};

			return images[status] || null;
		},
		getStatusText(data) {
			if ((data.status == "2" || data.status == "0") && data.retriggerRequest) {
				return "Requested";
			}
			if (data.status == "2") {
				return "Failed";
			}

			if (data.status == "0" && !data.expired) {
				if (data.pendingEvaluation) {
					return "Pending Evaluation";
				}
				if (data.type == "cvs" || data.type == "f2f") {
					return "Action required";
				}
			}
			if (data.type == "f2f" && this.selectedAssessment.linkedIn.status == 2) {
				return "Action Required";
			}
			if (data.type == "f2f" && this.selectedAssessment.linkedIn.status !== 1) {
				return "Pending LinkedIn Verification";
			}

			if (data.type == "f2f" && this.specialCase) {
				return "Action required";
			}
			if (
				// data.type == "assessment" &&
				!this.showResume &&
				this.showResume != null &&
				!data.retriggerRequest &&
				!data.pendingEvaluation
			) {
				return "Not Submitted";
			}

			if (data.expired) {
				return "Expired";
			}
			if (
				this.showResume == true &&
				this.showResume != null &&
				!data.retriggerRequest &&
				!data.pendingEvaluation &&
				!data.expired
			) {
				console.log("this.lastbufferTime", this.lastbufferTime);
				return `Expires in ${new Date(this.lastbufferTime).toLocaleTimeString(
					[],
					{ hour: "2-digit", minute: "2-digit", hour12: true }
				)}`;
			}
			return `Expires in ${data.expiresIn}`;
		},
		getStepText(id) {
			const stepTexts = ["one", "two", "three", "four"];
			return stepTexts[id - 1] || "four";
		},
		checkStatus(status) {
			return status == "0" || status == "2" || status == undefined;
		},
		getText(data) {
			if (!data) {
				return;
			}
			const {
				type,
				status,
				pendingEvaluation,
				retriggerIn,
				link,
				date,
				retriggerRequest,
				preferredSlot,
				expired,
			} = data;

			if (type === "f2f") {
				if (
					(status == "0" && pendingEvaluation) ||
					(this.interviewExpired && !pendingEvaluation)
				) {
					return "Interview Completed";
				}
				if (status === 0 && link && date) {
					return "Join Interview";
				}
				if (preferredSlot) {
					return "Getting Things Ready For You";
				}
				if (this.selectedAssessment.linkedIn.status == 2 && this.specialCase) {
					return "Re-Verify Linkedin";
				}
				if (this.selectedAssessment.linkedIn.status == 0 && this.specialCase) {
					return "Submitted For Verification";
				}
				return "Choose Slot";
			}

			if (type === "cvs") {
				if (status == "0" && !expired && !retriggerRequest) {
					return pendingEvaluation ? "Submitted" : "Start CVS";
				}
				if ((status == 2 || status == 0) && retriggerRequest) {
					return `Retrigger Requested`;
				} else if (status == "2") {
					return `Request For CVS - Expires in ${retriggerIn}`;
				} else if (status == "0" && expired) {
					return `Request For CVS - Test Expired`;
				}
			}

			if (type === "assessment" || type === "sandbox") {
				if (status == 0 && !expired && !retriggerRequest) {
					if (
						this.showResume &&
						this.showResume != null &&
						!pendingEvaluation
					) {
						return "Resume Test";
					}
					if (
						!this.showResume &&
						this.showResume != null &&
						!pendingEvaluation &&
						this.retriggerCount < 1
					) {
						return "Request For Retest-Test Expired";
					}
					if (
						!this.showResume &&
						this.showResume != null &&
						!pendingEvaluation &&
						this.retriggerCount >= 1
					) {
						return "Raise A  Query";
					}
					return pendingEvaluation ? "Submitted" : "Start Test";
				}
				if (status == 0 && expired && this.retriggerCount >= 1) {
					return "Raise A  Query";
				}
				if ((status == 2 || status == 0) && retriggerRequest) {
					return `Retrigger Requested`;
				}
				if (status == "0" && expired) {
					return `Request for retest - Test Expired`;
				}
			}

			if ((type === "assessment" || type === "sandbox") && status == "2") {
				if (status == 2 && retriggerRequest) {
					return `Retrigger Requested`;
				}
				return `Request for retest - Expires in ${retriggerIn}`;
			}

			return "Start Test";
		},
		getImgUrl(type) {
			const images = {
				f2f: require("../../assets/newdesign/BecomePanelist/interview-dp.svg"),
				sandbox: require("../../assets/newdesign/BecomePanelist/sandbox-dp.svg"),
				assessment: require("../../assets/newdesign/BecomePanelist/assess-dp.svg"),
				cvs: require("../../assets/newdesign/BecomePanelist/cvs-trigger-dp.svg"),
			};

			return images[type] || null;
		},
		async getCvsDetails() {
			try {
				this.loader = true;
				const response = await getCvsDetails();
				if (response.status == 200) {
					this.selectedAssessment = response.data.data;
					if (this.selectedAssessment.currentLevel == 4 && this.specialCase) {
						this.specialCase = false;
					}
					// this.selectedAssessment = this.data;
					const alert = this.selectedAssessment.progress.filter(
						(item) => item?.status == 0 && !item.pendingEvaluation
					);
					this.$forceUpdate();
				}
			} catch (error) {
				console.log(error);
			} finally {
				this.loader = false;
			}
		},
		goToresultdash() {
			this.$router.push({
				name: "ResultDashboard",
			});
		},
		formattedTime(time) {
			if (!time) return "";

			const utcTime = new Date(`1970-01-01T${time}`);
			return utcTime.toLocaleTimeString("en-US", {
				hour: "2-digit",
				minute: "2-digit",
				hour12: true,
			});
		},
		appendQuery(link, query) {
			// let url = new URL(link);
			// url.searchParams.append(query.key, query.value);
			// return url.href;
			const [baseUrl, fragment] = link.split("#");
			//checking for fragmentation in hire3x url

			if (fragment) {
				const [path, queryString] = fragment.split("?");
				const params = new URLSearchParams(queryString || "");
				params.append(query.key, query.value);

				return `${baseUrl}#${path}?${params.toString()}`;
			} else {
				const url = new URL(link);
				url.searchParams.append(query.key, query.value);

				return url.href;
			}
		},

		async goToCvs(data) {
			if (data.type == "f2f" && this.selectedAssessment.linkedIn.status == 2) {
				this.openLinkedinVerify();
				return;
			}
			if (
				(data.type == "assessment" || data.type == "sandbox") &&
				this.showResume == false &&
				this.showResume != null &&
				!data.pendingEvaluation &&
				!data.retriggerRequest &&
				this.retriggerCount >= 1
			) {
				this.$router.push({
					name: "MainProfile",
					query: {
						tab: "query",
					},
				});
				return;
			}
			const sandboxStep = this.selectedAssessment.progress.find((p) => p.type === "sandbox");
			if (
				(data.type == "f2f" && !data.status && !data.link) ||
				(data.type == "f2f" &&
				sandboxStep?.status == 0 &&
				sandboxStep?.pendingEvaluation) ||
				(sandboxStep?.skipped && data.type == "f2f")
			) {
				this.showSlots = true;
			}  else if (
				(data.status == 0 && data.expired) ||
				data.status == "2" ||
				(this.showResume == false &&
					this.showResume != null &&
					data.status == "0" &&
					!data.pendingEvaluation)
			) {
				const payload = {
					applicationID: this.selectedAssessment.applicationID,
					id: data.id,
					currentLevel: this.selectedAssessment.currentLevel,
				};
				this.currentId = data.id;
				// this.buttonLoader = true;
				this.currentId = data.id;
				this.$set(this.buttonLoader, data.id, true);
				const response = await triggerCvs(payload);
				if (response.status == 200) {
					this.successModal("Success", "Retrigger request sent!");
					this.getCvsDetails();
					this.$set(this.buttonLoader, data.id, false);
					this.currentId = null;
				}
			} else if (data.status == "0" && !data.pendingEvaluation) {
				let openUrl;
				if (!Capacitor.isNativePlatform()) {
					openUrl = this.appendQuery(data.link, {
						key: "from",
						value: "candidate",
					});
				} else {
					openUrl = data.link;
				}
				window.open(openUrl, "_blank");
			}
		},
		handleArrowClick() {
			if (this.isArrowDisabled) {
				return;
			}

			if (this.specialCase) {
				this.goToCvs(
					this.selectedAssessment.progress[
						this.selectedAssessment?.currentLevel
					]
				);
			} else {
				this.goToCvs(
					this.selectedAssessment.progress[
						this.selectedAssessment?.currentLevel - 1
					]
				);
			}
		},
		gotoProfile() {
			this.$router.push({
				name: "MyProfile",
			});
		},
	},
};
</script>

<style>
.appr-main-container {
	background-color: #e9ecef;
	height: calc(100vh - 60px);
	padding: 15px 15px 15px 75px;
	top: 60px;
	position: relative;
	display: flex;
	flex-direction: column;
	align-items: center;
}
.appr-down-cont {
	height: calc(100vh - 100px);
	overflow: auto;
}
.appr-panel-info {
	background-color: #f0f4ff;
	border-radius: 8px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 12px 63px 12px 17px;
	margin-top: 10px;
}

.appr-black-txt,
.appr-ur-txt {
	font-size: 20px;
}
.appr-grey-txt {
	font-size: 18px;
}
.appr-alert {
	border-radius: 4px;
	font-family: "Montserrat", sans-serif;
	font-size: 13px;
	font-weight: 500;
	display: flex;
	align-items: center;
	gap: 8px;
	padding: 2px 12px;
	margin-left: 20px;
}
.appr-red-alert {
	background: #d7342c1a;
	color: #ad1927;
}
.appr-yel-alert {
	background: #fff1ca;
	color: #f47529;
}
.appr-green-alert {
	background: #038e001f;
	color: #009045;
}
.appr-flex {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 12px;
	margin-top: 12px;
}
.appr-flex-2 {
	display: flex;
	align-items: center;
	gap: 12px;
}
.appr-flex-4 {
	display: flex;
	align-items: center;
	gap: 12px;
}
.appr-yellow-card {
	background-color: #fff6d7;
	border-radius: 8px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	font-family: "Lato", sans-serif;
	font-size: 18px;
	font-weight: 500;
	color: #333333;
	padding: 8px 40px 9px 13px;
	margin-top: 20px;
}

.appr-yellow-card .width {
	width: 75%;
}

.appr-hor-line {
	width: 44%;
	height: 1px;
	background-color: #caccce;
}

.appr-horizontal-scroll {
	width: 100%;
	display: flex;
	overflow-x: auto;
}
.appr-card-parent {
	display: flex;
	align-items: center;
	flex-wrap: nowrap;
}
.appr-horizontal-scroll::-webkit-scrollbar {
	scroll-behavior: smooth !important;
	width: 0px !important;
	height: 0px !important;
	background-color: transparent !important;
}
.asspr-cards.card {
	position: relative;
	min-width: 390px;
	width: 390px;
	border-radius: 12px;
	background-color: #fff;
	border: none;
}
.asspr-cards .card-body {
	padding: 0;
}
.appr-grey-tag {
	background: #20639b33;
	border-radius: 20px;
	padding: 2px 10px;
	font-family: "Lato", sans-serif;
	font-size: 14px;
	font-weight: 400;
	color: #333333;
	width: fit-content;
}
.appr-card-footer {
	background-color: #ffe0744a;
	display: flex;
	align-items: center;
	justify-content: center;
	height: 65px;
	padding-inline: 20px;
	border-radius: 0px 0px 12px 12px;
}
.appr-card-footer-green {
	background-color: #e8ffe8;
	display: flex;
	align-items: center;
	justify-content: center;
	height: 64px;
	padding-inline: 20px;
	border-radius: 0px 0px 12px 12px;
	font-family: "Montserrat", sans-serif;
	font-size: 18px;
	font-weight: 700;
	color: #038e00;
}
.appr-card-footer-grey {
	background-color: #ececec;
	display: flex;
	align-items: center;
	justify-content: center;
	height: 65px;
	padding-inline: 20px;
	border-radius: 0px 0px 12px 12px;
	font-family: "Montserrat", sans-serif;
	font-size: 18px;
	font-weight: 700;
	color: #7a7a7a;
}

.appr-green-border {
	border: 2px solid #038e00 !important;
}

.appr-red-border {
	border: 2px solid #ad1927 !important;
}
.appr-white-border {
	border: 2px solid #ffffff;
}

.appr-grey-border {
	border: 2px solid #8c8c8c !important;
}

.appr-opacity {
	opacity: 0.7;
	pointer-events: none;
}

.appr-blue-slot {
	background-color: #f0f4f8;
	margin-inline: -16px;
	padding: 10px 20px;
}

.appr-blue-slot h3 {
	font-size: 16px;
}
.appr-blue-slot h4 {
	font-size: 20px;
}
.appr-blue-slot h5 {
	font-size: 14px;
	color: #595959;
}

.appr-card-height {
	height: 160px;
	display: flex;
	flex-direction: column;
	padding-top: 20px;
}
.appr-card-height-2 {
	height: 160px;
	display: flex;
	flex-direction: column;
	padding-top: 20px;
}
.appr-card-txt {
	font-family: "Lato", sans-serif;
	font-size: 16px;
	font-weight: 400;
	color: #333333;
}
.appr-card-red-tag {
	display: flex;
	align-items: center;
	background-color: #d7342c1a;
	border-radius: 4px;
	height: 39px;
	width: fit-content;
	padding-inline: 20px;
	gap: 8px;
	font-family: "Montserrat", sans-serif;
	font-size: 14px;
	font-weight: 500;
	color: #ad1927;
}
.appr-card-yellow-tag {
	display: flex;
	align-items: center;
	background-color: #ffdd806b;
	border-radius: 4px;
	height: 39px;
	width: fit-content;
	padding-inline: 20px;
	gap: 8px;
	font-family: "Montserrat", sans-serif;
	font-size: 14px;
	font-weight: 500;
	color: #f47529;
}
.appr-card-green-tag {
	display: flex;
	align-items: center;
	background-color: #e4eeff;
	border-radius: 4px;
	height: 39px;
	width: fit-content;
	padding-inline: 20px;
	gap: 8px;
	font-family: "Montserrat", sans-serif;
	font-size: 14px;
	font-weight: 500;
	color: #038e00;
}
.appr-card-grey-tag {
	display: flex;
	align-items: center;
	background-color: #ececec;
	border-radius: 4px;
	height: 39px;
	width: fit-content;
	padding-inline: 20px;
	gap: 8px;
	font-family: "Montserrat", sans-serif;
	font-size: 14px;
	font-weight: 500;
	color: #7a7a7a;
}
.appr-panel-info .status {
	text-align: center;
}
.interslot-body {
	padding: 20px;
}
.interslot-cross {
	position: absolute;
	right: 22px;
	top: 24px;
}
.interslot-body article {
	background: #ffe0744a;
	border-radius: 6px;
	padding: 10px 15px;
	font-family: "Lato", sans-serif;
	font-size: 16px;
	font-weight: 500;
	color: #333333;
}
.interslot-body span {
	color: #344054;
}
.time-select-parent {
	height: 200px;
	overflow: auto;
	display: flex;
	flex-wrap: wrap;
	border-top: 1px solid #8c8c8c59;
}

.time-select-parent .single-time {
	font-family: "Montserrat", sans-serif;
	font-size: 14px;
	font-weight: 500;
	color: #333333;
	text-align: center;
	padding-block: 20px;
	border: 2px solid #ffffff;
	border-bottom: 1px solid #8c8c8c59;
	width: calc(100% / 3);
	position: relative;
}
.time-select-parent .single-time-sel,
.select-date-parent .single-time-sel {
	background-color: #f1f7ff;
	border: 2px solid #20639b;
	border-radius: 4px;
}
.time-select-parent .single-time-vertical-line {
	height: 40px;
	width: 1px;
	background-color: #8c8c8c59;
	position: absolute;
	right: 0px;
	top: 10px;
}
.select-date-parent {
	display: flex;
	gap: 20px;
	width: 100%;
	overflow-x: auto;
}
.select-date-parent::-webkit-scrollbar {
	scroll-behavior: smooth !important;
	width: 0px !important;
	height: 0px !important;
	background-color: transparent !important;
}
.single-time-date {
	color: #ffffff;
	border: 2px solid #8c8c8c59;
	box-shadow: 0px 2px 6px 0px #00000040;
	border-radius: 4px;
	width: 120px;
	padding-block: 7px;
	flex-shrink: 0;
}
.select-date-left {
	position: absolute;
	z-index: 4;
	left: -20px;
	top: 8px;
}
.select-date-right {
	position: absolute;
	z-index: 4;
	right: -20px;
	top: 8px;
}
.appr-modal-heading {
	text-align: center;
	color: #20639b;
	font-size: 20px;
	font-weight: 700;
}
.appr-flex-3 {
	display: flex;
	align-items: center;
}
@media only screen and (max-width: 1028px) {
	.w-92px {
		width: 92px;
		flex-shrink: 0;
	}
	.appr-flex-2 {
		display: flex;
		align-items: center;
		gap: 12px;
	}
	.appr-flex-4 {
		display: flex;
		align-items: unset !important;
		justify-content: unset !important;
		gap: 12px;
	}
	.appr-main-container {
		background-color: #e9ecef;
		height: calc(
			100dvh - (60px + env(safe-area-inset-top) + env(safe-area-inset-bottom))
		);
		padding: 15px;
		overflow: auto;
		/* position: fixed; */
		top: unset;
		display: block;
	}
	.appr-card-height {
		height: 125px;
	}
	.appr-card-height-2 {
		height: 147px;
	}
	.appr-hello-svg {
		height: 16px;
		width: 16px;
	}
	.appr-black-txt {
		font-size: 16px;
	}
	.appr-ur-txt {
		font-size: 14px;
	}
	.appr-card-txt {
		font-size: 13px;
	}
	.appr-card-footer-green,
	.appr-card-footer-grey {
		font-size: 16px;
		font-weight: 600;
	}
	.appr-card-footer,
	.appr-card-footer-green,
	.appr-card-footer-grey {
		height: 55px;
	}
	.appr-card-grey-tag,
	.appr-card-green-tag,
	.appr-card-red-tag,
	.appr-card-yellow-tag {
		font-size: 13px;
	}
	.appr-down-cont {
		height: 100%;
		overflow: auto;
	}
	.appr-panel-info {
		position: relative;
	}
	.appr-alert {
		font-size: 10px;
		gap: 6px;
		padding: 2px 8px;
		margin-left: 0px;
		position: absolute;
		top: -8px;
		left: -8px;
	}

	.appr-red-alert-2 {
		position: unset !important;
	}
	.appr-flex {
		flex-direction: column;
		align-items: flex-start;
		gap: 5px;
		width: 100%;
		margin-top: 10px;
	}
	.appr-grey-txt {
		font-size: 12px;
	}
	.appr-mob-width {
		width: calc(100% - 150px);
	}
	.appr-panel-info .status {
		text-align: unset;
		display: flex;
		align-items: center;
		gap: 10px;
		background-color: #e3eaff;
		border-radius: 8px;
		padding: 5px 10px;
		position: absolute;
		right: 15px;
		top: 15px;
	}
	.appr-panel-info .status h1 {
		font-size: 16px;
		margin-bottom: 0;
	}
	.appr-panel-info .status h2 {
		font-size: 13px;
		margin-bottom: 0;
	}
	.appr-panel-info {
		padding: 21px 15px;
	}
	.appr-yellow-card {
		font-size: 13px;
		padding: 10px;
	}
	.appr-yellow-card .width {
		width: 80%;
	}
	.appr-hor-line {
		width: 35%;
	}
	.appr-horizontal-scroll {
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;

		overflow-x: auto;
	}
	.appr-card-parent {
		display: flex;
		flex-direction: column;
		align-items: center;
		flex-wrap: nowrap;
		width: 100%;
	}
	.asspr-cards.card {
		min-width: 100%;
		width: 100%;
	}
	.asspr-cards .mob-img {
		height: 42px;
	}
	.asspr-cards .candash-addBtn-ats.btn-secondary {
		padding: 7px !important;
	}
	.appr-modal-heading {
		text-align: left;
		color: #000000;
		font-size: 16px;
		font-weight: 600;
	}
	.interslot-body article {
		padding: 7px 12px;
	}
	.time-select-parent .single-time {
		padding-block: 12px;
	}
	#interviewSlot .modal-dialog-centered {
		align-items: flex-end !important;
		min-height: 100% !important;
	}
	#interviewSlot .modal-dialog {
		margin: 0 !important;
	}
	.appr-w-100 {
		width: 100%;
	}
	.appr-flex-3 {
		display: flex;
		align-items: center;
		justify-content: space-between;
		width: 100%;
	}
}
</style>
